import React, { useState, useEffect } from "react";
import { Button, Table, Modal, Card } from "antd";
import { withRouter } from "react-router";
import { getSubUserList, removeSubUser, transferMainAccount } from "@/services/api/user";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./index.css";

function AddSubAccount(props) {
  const Columns = [
    {
      title: "用户名",
      dataIndex: "remark",
    },
    {
      title: "账户类型",
      dataIndex: "mainAccount",
      render(text, record, index) {
        return text ? "主账号" : "子账号";
      },
    },
    {
      title: "微信昵称",
      dataIndex: "nickName",
    },
    {
      title: "状态",

      render() {
        return "绑定";
      },
    },
    {
      title: "操作",

      render: (text, record, index) => {
        if (!record.mainAccount) {
          return (
            <div>
              <Button type="link" onClick={() => handleRemove(record.id)}>
                解绑
              </Button>

              <Button type="link" onClick={() => setMainAccount(record.id, record.nickName)}>
                设为主账号
              </Button>
            </div>
          );
        } else {
          return null;
        }
      },
    },
  ];

  const [data, setData] = useState(null);
  const handleAddWeChat = () => {
    if (data.length >= 10) {
      Modal.info({
        title: "子账号数量已达上限" + data.length + "/10",
        content: "请先解绑不用的子账号再来添加",
      });
      return;
    }
    props.history.push("/WeChat/management/add/inputName");
  };

  const handleRemove = (id) => {
    Modal.confirm({
      title: "确认解绑该子账号吗？",
      content: "解绑后该子账号将无法正常登录",
      icon: <ExclamationCircleOutlined />,
      onOk: async (e) => {
        await removeSubUser(id);

        await getInfo();
        e();
      },
    });
  };

  const setMainAccount = (id, name) => {
    Modal.confirm({
      title: "确认将子账号_" + name + "设置为主账号吗？",
      content: "设置后您将不能管理子账号",
      icon: <ExclamationCircleOutlined />,
      onOk: async (e) => {
        await transferMainAccount(id);

        await getInfo();
        e();
      },
    });
  };

  const getInfo = async () => {
    const result = await getSubUserList();
    const newData = result.reduce((pre, cur, index, arr) => {
      !cur.mainAccount ? pre.push(cur) : pre.unshift(cur);
      return pre;
    }, []);
    setData(newData);
  };
  useEffect(() => {
    getInfo();
  }, []);

  return (
    <Card>
      <Button type="primary" onClick={handleAddWeChat} className="mb20">
        添加微信子账号
      </Button>

      <Table size="small" rowKey="id" columns={Columns} dataSource={data} pagination={false} />
    </Card>
  );
}

export default withRouter(AddSubAccount);
